import storage from 'good-storage'

const collectible_value_list = '__collectible_value_list__'
const breed_list = '__breed_list__'
const color_list = '__color_list__'
const accessory_list = '__accessory_list__'


export function getCollectibleValueList() {
  return storage.get(collectible_value_list, ['2', '4', '6'])
}
export function setCollectibleValueList(flag) {
  storage.set(collectible_value_list, flag)
  return flag
}

export function getBreedList() {
  return storage.get(breed_list, [])
}
export function setBreedList(flag) {
  storage.set(breed_list, flag)
  return flag
}

export function getColorList() {
  return storage.get(color_list, ['Original-Colours'])
}
export function setColorList(flag) {
  storage.set(color_list, flag)
  return flag
}

export function getAccessoryList() {
  return storage.get(accessory_list, ['Bow-Tie', 'Fancy-Hat', 'Ball-Cap', 'Reading-Glasses', 'Scarf', 'Goggles', 'Toque', 'Glasses'])
}
export function setAccessoryList(flag) {
  storage.set(accessory_list, flag)
  return flag
}